<script type="text/javascript">
	import IconButton from '@smui/icon-button';
	import { afterUpdate,createEventDispatcher,onMount } from "svelte";
	import "./ModalWindow.scss";
	import ModalWindowGroupStore from "./ModalWindow/Store";
			
	const dispatch = createEventDispatcher(); // close

	export let materialIcon = "";
	export let title = "";
	export let hasBackground = true;
	export let hasCloseButton = true;
	export let fullscreen = false;
	export let draggable = true;
	export let resizable = true;
	export let open = false;
	let prevOpenState = null;
	export let padding = true;

	export let parent = null;

	export let group = null;

	// TODO: Build a proper docking layout system?
	export let position = "center"; // center | top-left | top-right

	export let height = "";
	let myHeight = height;

	let style = (myHeight !== "")
		? ("height:"+height)
		: "";

	export let layer = 0; // 0 - 3 for layers. 3 is highest

	let containerElement;
	let contentElement;
	export function scrollToTop() {
		contentElement.scrollTop = 0;
	}

	onMount(() => {
		if (group == null) {
			group = ModalWindowGroupStore.defaultGroup;
		}
		// TODO: re-think if we can get a reference to "this" component. Looks like we can't?
		group.attach(containerElement, elmnt, layer);
	});
	afterUpdate(() => {
		if (prevOpenState !== open && open) {
			group.bringToTop(containerElement, elmnt);
		}
		prevOpenState = open;
	});


	let closeAction = () => {
		open = false;
		dispatch("close");
	}

	let mouseDown = (e) => {
		// TODO: "bring to top"
		if (group) {
			group.bringToTop(containerElement, elmnt);
		}
	}

	// Make the DIV element draggable:
	let elmnt;
	let pos1, pos2, pos3, pos4;
	let dragMouseDown = (e) =>{
		if (!draggable) { return; }
		e = e || window.event;
		e.preventDefault();

		// get the mouse cursor position at startup:
		pos3 = e.clientX;
		pos4 = e.clientY;
		document.onmouseup = closeDragElement;
		document.onpointerup = closeDragElement;

		// call a function whenever the cursor moves:
		document.onmousemove = elementDrag;
		document.onpointermove = elementDrag;
	}

	let elementDrag = (e) => {
		if (!draggable) { return; }

		e = e || window.event;
		e.preventDefault();

		// calculate the new cursor position:
		pos1 = pos3 - e.clientX;
		pos2 = pos4 - e.clientY;
		pos3 = e.clientX;
		pos4 = e.clientY;

		// set the element's new position:
		elmnt.style.top = (elmnt.offsetTop - pos2) + "px";
		elmnt.style.left = (elmnt.offsetLeft - pos1) + "px";
	}

	let windowPaddingX = 32;
	let windowPaddingTop = 70;
	let windowPaddingBottom = 56;

	let closeDragElement = () => {
		if (!draggable) { return; }

		// Check bounds and make sure it stays in the window bounds at least 5 pixels.
		if (windowPaddingX != -1) {
			elmnt.style.left = Math.max(elmnt.offsetLeft, 0 + windowPaddingX) + "px";

			let explicitWidth = parseInt(elmnt.style.width);
			explicitWidth = Number.isNaN(explicitWidth)?0:explicitWidth;

			elmnt.style.left = Math.min(elmnt.offsetLeft, window.innerWidth - windowPaddingX - explicitWidth) + "px";
		}
		if (windowPaddingBottom) {
			elmnt.style.top = Math.min(elmnt.offsetTop, window.innerHeight - windowPaddingBottom) + "px";
		}
		if (windowPaddingTop) {
			elmnt.style.top = Math.max(elmnt.offsetTop, 0 + windowPaddingTop) + "px";
		}
		// stop moving when mouse button is released:
		document.onmouseup = null;
		document.onmousemove = null;
		document.onpointerup = null;
		document.onpointermove = null;
	}
</script>

<div bind:this={containerElement}>
	{#if hasBackground}
		<div class="modal-background" class:hidden={!open} on:click={closeAction}
			class:l0={layer==0} class:l1={layer==1} class:l2={layer==2} class:l3={layer==3}></div>
	{/if}

	<div class={"modal mdc-elevation--z10 position-" + position} class:position-is-child={parent !== null} style={style} class:fullscreen={fullscreen} class:hidden={!open} bind:this={elmnt} class:resizable={resizable}
		class:l0={layer==0} class:l1={layer==1} class:l2={layer==2} class:l3={layer==3}
		on:mousedown={mouseDown}
		on:pointerdown={mouseDown}
		>
		<div class="bar" on:mousedown={dragMouseDown} on:mouseup={closeDragElement} on:pointerdown={dragMouseDown} on:pointerup={closeDragElement} class:draggable={draggable}>
			{#if materialIcon.length > 0}
				<div class='material-icons'>{materialIcon}</div>
			{/if}
			<h1 class="title">{title}</h1>
			<div class='icon-button fr' class:hidden={!hasCloseButton}>
				<IconButton on:click={closeAction} class="material-icons" title="Close">close</IconButton>
			</div>
		</div>
		<div class="content" bind:this={contentElement} class:padding={padding}>
			<slot />
		</div>
	</div>
</div>
